import { Link } from "react-router-dom";
import { Shield, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const SECTIONS = [
    {
        n: "1",
        title: "Titolare del trattamento",
        body: (
            <>
                <p>Il Titolare del trattamento dei dati personali è:</p>
                <p className="mt-3">
                    <strong>Nowgestioni S.r.l.</strong>
                    <br />
                    Legale Rappresentante: <strong>Dott. Luigi Colaianni</strong>
                    <br />
                    Email: <a href="mailto:info@nowgestioni.it" className="text-primary hover:underline">info@nowgestioni.it</a>
                </p>
                <p className="mt-3">
                    La presente informativa descrive le modalità di raccolta, utilizzo, conservazione e protezione dei dati personali degli utenti che utilizzano la piattaforma <strong>CondominioNow — L'esperto risponde</strong>.
                </p>
            </>
        ),
    },
    {
        n: "2",
        title: "Chi siamo",
        body: (
            <>
                <p>
                    <strong>CondominioNow</strong> è un servizio informativo gratuito sviluppato da Nowgestioni S.r.l., società specializzata nell'amministrazione condominiale e nella gestione di patrimoni immobiliari.
                </p>
                <p className="mt-3">
                    La piattaforma nasce con l'obiettivo di aiutare condomini, proprietari e cittadini a orientarsi nel complesso mondo del condominio attraverso informazioni chiare, facilmente accessibili e fornite da professionisti del settore.
                </p>
            </>
        ),
    },
    {
        n: "3",
        title: "Dati raccolti",
        body: (
            <>
                <p>Durante l'utilizzo della piattaforma possono essere raccolti:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>Nome e cognome</li>
                    <li>Indirizzo email</li>
                    <li>Password criptata</li>
                    <li>Domande inviate tramite la piattaforma</li>
                    <li>Eventuali allegati caricati dall'utente</li>
                    <li>Dati tecnici necessari al funzionamento del servizio</li>
                    <li>Log di accesso e dati di sicurezza</li>
                </ul>
            </>
        ),
    },
    {
        n: "4",
        title: "Finalità del trattamento",
        body: (
            <>
                <p>I dati personali vengono trattati per:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>Consentire la registrazione e l'accesso alla piattaforma</li>
                    <li>Gestire gli account degli utenti</li>
                    <li>Gestire le richieste e le domande inviate</li>
                    <li>Fornire risposte e informazioni tramite il servizio</li>
                    <li>Garantire la sicurezza della piattaforma</li>
                    <li>Adempiere ad eventuali obblighi di legge</li>
                </ul>
            </>
        ),
    },
    {
        n: "5",
        title: "Base giuridica del trattamento",
        body: (
            <>
                <p>Il trattamento dei dati è effettuato:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>Per l'esecuzione dei servizi richiesti dall'utente</li>
                    <li>Per l'adempimento di obblighi legali</li>
                    <li>Per il perseguimento del legittimo interesse del Titolare alla sicurezza e corretta gestione della piattaforma</li>
                    <li>Sulla base dell'eventuale consenso prestato dall'utente quando richiesto</li>
                </ul>
            </>
        ),
    },
    {
        n: "6",
        title: "Conservazione dei dati",
        body: (
            <>
                <p>I dati saranno conservati per il tempo necessario all'erogazione del servizio e all'adempimento degli obblighi di legge.</p>
                <p className="mt-3">I dati dell'account potranno essere conservati fino alla richiesta di cancellazione da parte dell'utente, salvo diversi obblighi normativi.</p>
            </>
        ),
    },
    {
        n: "7",
        title: "Comunicazione dei dati",
        body: (
            <>
                <p>I dati personali non saranno ceduti o venduti a terzi per finalità commerciali.</p>
                <p className="mt-3">Potranno essere comunicati esclusivamente a fornitori di servizi tecnici necessari al funzionamento della piattaforma o alle Autorità competenti nei casi previsti dalla legge.</p>
            </>
        ),
    },
    {
        n: "8",
        title: "Sicurezza",
        body: (
            <p>Nowgestioni S.r.l. adotta adeguate misure tecniche e organizzative per proteggere i dati personali da accessi non autorizzati, perdita, alterazione o divulgazione.</p>
        ),
    },
    {
        n: "9",
        title: "Diritti dell'interessato",
        body: (
            <>
                <p>L'utente può esercitare in qualsiasi momento i diritti previsti dal GDPR, inclusi:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>Accesso ai propri dati</li>
                    <li>Rettifica dei dati</li>
                    <li>Cancellazione dei dati</li>
                    <li>Limitazione del trattamento</li>
                    <li>Opposizione al trattamento</li>
                    <li>Portabilità dei dati</li>
                </ul>
            </>
        ),
    },
    {
        n: "10",
        title: "Esercizio dei diritti",
        body: (
            <>
                <p>Per esercitare i propri diritti è possibile contattare:</p>
                <p className="mt-3">
                    <strong>Nowgestioni S.r.l.</strong>
                    <br />
                    Email: <a href="mailto:info@nowgestioni.it" className="text-primary hover:underline">info@nowgestioni.it</a>
                </p>
            </>
        ),
    },
    {
        n: "11",
        title: "Reclamo all'Autorità Garante",
        body: (
            <p>L'utente ha il diritto di proporre reclamo al <strong>Garante per la Protezione dei Dati Personali</strong> qualora ritenga che il trattamento dei propri dati avvenga in violazione della normativa vigente.</p>
        ),
    },
    {
        n: "12",
        title: "Modifiche alla presente informativa",
        body: (
            <>
                <p>Nowgestioni S.r.l. si riserva il diritto di modificare o aggiornare la presente Privacy Policy in qualsiasi momento.</p>
                <p className="mt-3">Le modifiche saranno pubblicate su questa pagina.</p>
            </>
        ),
    },
    {
        n: "13",
        title: "Contatti",
        body: (
            <p>
                <strong>CondominioNow — L'esperto risponde</strong>
                <br />
                Un servizio di Nowgestioni S.r.l.
                <br />
                Email: <a href="mailto:info@nowgestioni.it" className="text-primary hover:underline">info@nowgestioni.it</a>
            </p>
        ),
    },
    {
        n: "14",
        title: "Missione del servizio",
        body: (
            <>
                <p>CondominioNow nasce con l'obiettivo di rendere le informazioni condominiali più accessibili, comprensibili e utili per tutti.</p>
                <p className="mt-3">Crediamo che una persona correttamente informata possa affrontare con maggiore serenità le sfide della vita condominiale. Per questo mettiamo gratuitamente la nostra esperienza al servizio della comunità.</p>
            </>
        ),
    },
];

export default function PrivacyPolicy() {
    return (
        <div className="bg-white">
            {/* HERO */}
            <section className="relative overflow-hidden border-b border-slate-200">
                <div
                    aria-hidden
                    className="absolute inset-0 bg-[radial-gradient(1000px_400px_at_-10%_-20%,rgba(15,76,129,0.08),transparent_60%)]"
                />
                <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                    <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 border border-primary/20 px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-primary" data-testid="privacy-badge">
                        <Shield className="size-3.5" /> GDPR · Regolamento (UE) 2016/679
                    </div>
                    <h1
                        data-testid="privacy-title"
                        className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight text-slate-900"
                    >
                        Privacy Policy
                    </h1>
                    <p className="mt-4 text-lg text-slate-600 max-w-2xl leading-relaxed">
                        Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (<em>"GDPR"</em>).
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground" data-testid="privacy-updated">
                        Ultimo aggiornamento: <strong>Agosto 2026</strong>
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
                    {/* Sticky index */}
                    <aside className="hidden lg:block">
                        <div className="sticky top-24">
                            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-3">Indice</div>
                            <ol className="space-y-1.5 text-sm">
                                {SECTIONS.map(s => (
                                    <li key={s.n}>
                                        <a href={`#sez-${s.n}`} className="flex items-start gap-2 text-slate-600 hover:text-primary transition py-0.5">
                                            <span className="text-slate-400 font-mono text-xs w-5 shrink-0">{s.n}.</span>
                                            <span className="leading-snug">{s.title}</span>
                                        </a>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </aside>

                    {/* Sections */}
                    <article className="min-w-0" data-testid="privacy-content">
                        <div className="space-y-8">
                            {SECTIONS.map(s => (
                                <section
                                    key={s.n}
                                    id={`sez-${s.n}`}
                                    className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-6 lg:p-8 shadow-[0_1px_2px_0_rgba(0,0,0,0.04)]"
                                    data-testid={`privacy-section-${s.n}`}
                                >
                                    <div className="flex items-start gap-4">
                                        <div className="shrink-0 size-10 rounded-xl bg-primary/10 flex items-center justify-center">
                                            <span className="font-serif text-lg font-semibold text-primary">{s.n}</span>
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <h2 className="font-serif text-2xl font-semibold text-slate-900 leading-tight">{s.title}</h2>
                                            <div className="mt-3 text-slate-700 leading-relaxed text-[15px]">{s.body}</div>
                                        </div>
                                    </div>
                                </section>
                            ))}
                        </div>

                        {/* Contact CTA */}
                        <div className="mt-10 rounded-2xl bg-slate-950 text-white p-8 lg:p-10" data-testid="privacy-contact-cta">
                            <div className="flex items-start gap-4 flex-wrap">
                                <div className="size-12 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                                    <Mail className="size-5 text-amber-400" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h3 className="font-serif text-2xl font-semibold">Hai una domanda sulla privacy?</h3>
                                    <p className="mt-2 text-slate-300 text-sm">
                                        Scrivici a <a href="mailto:info@nowgestioni.it" className="text-amber-300 underline underline-offset-4 hover:text-amber-200">info@nowgestioni.it</a> per esercitare i tuoi diritti o richiedere informazioni.
                                    </p>
                                </div>
                                <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold rounded-full">
                                    <Link to="/come-funziona">Scopri come funziona <ArrowRight className="size-4 ml-1" /></Link>
                                </Button>
                            </div>
                        </div>
                    </article>
                </div>
            </section>
        </div>
    );
}
